import { render } from "./CategoryNewModalPopup.vue?vue&type=template&id=7cc173cb&scoped=true"
import script from "./CategoryNewModalPopup.vue?vue&type=script&lang=js"
export * from "./CategoryNewModalPopup.vue?vue&type=script&lang=js"

import "./CategoryNewModalPopup.vue?vue&type=style&index=0&id=7cc173cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc173cb"]])

export default __exports__